// app/javascript/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  copy() {
    if (!this.hasInputTarget) return

    navigator.clipboard.writeText(this.inputTarget.value)
      .then(() => {
        // feedback visivo
        this.inputTarget.classList.add("border-success")
        setTimeout(() => this.inputTarget.classList.remove("border-success"), 600)
      })
      .catch(err => console.error("Errore copia negli appunti:", err))
  }
}